import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-clean-layout',
  templateUrl: './clean-layout.component.html',
  styleUrl: './clean-layout.component.scss',
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CleanLayoutComponent {}
